import assetPath from '/app/packages/entity-pages/entity-pages-news-commbox/src/components/upload/assets/upload.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')